import { faExchange } from '@fortawesome/pro-regular-svg-icons/faExchange';
import React from 'react';
import { Resource } from '../../../../common/constants/resource';
import { handleClick } from './helper';
import NavLink from './NavLink';
import * as styles from './styles.module.scss';

const Decision = ({
  isActive,
  setActive,
  dataLinkId,
}: {
  isActive?: boolean;
  setActive?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  dataLinkId: string;
}) => {
  const onClick = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    handleClick(ev, setActive);
  };
  const iconLinkContainerClasses = `${styles.LeftNavIconLinkContainer} ${styles.IconLinkContainer}`;

  const linkClass: string = `${styles.LinkRight} ${
    isActive ? styles.Active : ''
  }`;

  const iconClass = `${styles.Icon} ${isActive ? styles.Active : ''}`;

  return (
    <NavLink
      dataLinkId={dataLinkId}
      icon={faExchange}
      iconClassName={iconClass}
      iconContainerClassName={iconLinkContainerClasses}
      textClassName={linkClass}
      copy={Resource.TASK_TITLE_DECISION}
      onClick={onClick}
    />
  );
};

export default Decision;
